<template>
    <div style="margin-top:20px;">
        <header-tag class="header-tip" :title="'云笔记'"></header-tag>
        <div class="cloud-note" v-show="!loading">
            <div class="note-header">
                <a href="#" v-show="!contenteditable" @click.prevent="edit"
                    >编辑</a
                >
                <a href="#" v-show="contenteditable" @click.prevent="save"
                    >保存</a
                >
                <a href="#" v-show="contenteditable" @click.prevent="cancel"
                    >取消</a
                >
            </div>
            <div
                class="note-content"
                ref="note"
                v-html="oldNote"
                :contenteditable="contenteditable"
            ></div>
        </div>
        <no-data
            style="height:auto;padding-top:20px;padding-bottom:20px;"
            :loading="loading"
        ></no-data>
    </div>
</template>
<script>
// tag组件
import HeaderTag from "_c/tagTitle/headerTag";
import NoData from "_c/noData/noData";
import { getCloudNote, editCloudNote } from "@/requests/bar";

export default {
    components: {
        HeaderTag,
        NoData
    },
    props: {},
    data() {
        return {
            oldNote: "",
            contenteditable: false,
            loading: false
        };
    },
    mounted() {
        this.init();
        this.$domFn.addListen(this.$refs.note, "paste", e =>
            this.handlePaste(e)
        );
    },
    watch: {
        /* eslint-disable */
        $route(to, from) {
            this.init();
        }
    },
    methods: {
        init() {
            this.getCloudNote();
        },
        handlePaste(e) {
            e.preventDefault();
            let pastedText;
            if (window.clipboardData && window.clipboardData.getData) {
                // IE
                pastedText = window.clipboardData.getData("Text");
            } else {
                pastedText = e.clipboardData.getData("Text"); //e.clipboardData.getData('text/plain');
            }
            this.oldNote += pastedText;
        },
        async getCloudNote() {
            this.loading = true;
            if (this.$route.params.id == undefined) {
                return false;
            }
            let str = await getCloudNote({
                barId: this.$route.params.id
            });
            this.oldNote = str === null ? "" : str;
            this.loading = false;
        },
        edit() {
            this.contenteditable = true;
            this.$nextTick(() => {
                this.$refs.note.focus();
                this.$refs.note.style.background = "#fff";
            });
        },
        async save() {
            let res = await editCloudNote({
                barId: this.$route.params.id,
                note: encodeURIComponent(this.$refs.note.innerHTML)
            });
            if (res.code == 200) {
                this.contenteditable = false;
                this.$refs.note.style.background = "#f5f6fa";
            } else {
                window.$Message.show({
                    title: "修改云笔记",
                    type: "error",
                    msg: res.msg
                });
            }
        },
        cancel() {
            this.getCloudNote();
            this.contenteditable = false;
            this.$refs.note.style.background = "#f5f6fa";
        }
    }
};
</script>
<style lang="scss" scoped>
.cloud-note {
    width: 90%;
    background-color: rgba(247, 247, 247, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(230, 230, 230, 1);
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    overflow: hidden;
}
.header-tip {
    margin-bottom: 10px;
}
.note-header {
    width: 100%;
    height: 31px;
    line-height: 31px;
    background: inherit;
    background-color: rgba(245, 246, 250, 1);
    box-sizing: border-box;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    border-radius: 0px;
    box-sizing: border-box;
    font-size: 12px;
    a {
        color: #0066cc;
        text-indent: 12px;
    }
    text-align: left;
}
.note-content {
    height: 260px;
    // min-height: 260px;
    // max-height: 400px;
    padding: 8px;
    outline: none;
}
</style>
